var React = require('react');

function Mobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.625 0H6.625C5.72888 0 5 0.728 5 1.625V24.375C5 25.2727 5.728 26 6.625 26H19.625C20.5227 26 21.25 25.2727 21.25 24.375V1.625C21.25 0.728882 20.5227 0 19.625 0ZM12.3125 1.625H13.9375C14.3851 1.625 14.75 1.98899 14.75 2.4375C14.75 2.88601 14.3851 3.25 13.9375 3.25H12.3125C11.864 3.25 11.5 2.88601 11.5 2.4375C11.5 1.98899 11.864 1.625 12.3125 1.625ZM13.9375 24.375H12.3125C11.864 24.375 11.5 24.0101 11.5 23.5625C11.5 23.1149 11.864 22.75 12.3125 22.75H13.9375C14.3851 22.75 14.75 23.1149 14.75 23.5625C14.75 24.0101 14.3851 24.375 13.9375 24.375ZM19 21.125H7V4.875H19V21.125Z"}));
}

Mobile.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"color"};

module.exports = Mobile;

Mobile.default = Mobile;
